export default __webpack_public_path__ + "static/media/100005.07dbc2fa.jpg";